let livemode=true;
let baseUrl='';
let logoUrl ='';
let Flagurl ='';
let KYCurl ='';

if (livemode) {
    baseUrl='https://courierdai.com/api/';
    logoUrl ='https://cdn.courierdai.com/Logo/';
    Flagurl = 'https://cdn.courierdai.com/Flag/';
    KYCurl = 'https://cdn.courierdai.com/KYC/';
    
} else {
    baseUrl='http://192.168.29.107:8000/api/';
    logoUrl ='https://cdn.courierdai.com/Logo/';
    Flagurl = 'https://cdn.courierdai.com/Flag/';
    KYCurl = 'https://cdn.courierdai.com/KYC/';
}
let Global={
    baseUrl:baseUrl,
    logoUrl:logoUrl,
    flagurl:Flagurl,
    kyc:KYCurl,
    timezone:'Asia/Kolkata'
};
export default Global;

